import { IParams } from '../params';

export const suburbanParams: (keyof IParams)[] = [
  'publishPeriod',
  'isByHomeowner',
  'video',
  'withPhoto',
  'rentTime',
  'houseArea',
  'landArea',
  'houseMaterial',
  'floorsTotal',
  'layout',
  'heatingType',
  'suburbanBathroom',
  'bedrooms',
  'repair',
  'facilities',
  'tenants',
  'rentTerms',
  'comission',
  'suburbanUtilities',
  'landStatus',
  'houseYear',
  'mkadDistance',
  'wordsInclude',
  'wordsExclude',
  'phone',
  'offerId',
];
